import React from 'react';
import { LinearScale, CategoryScale, Filler, BarElement, PointElement, LineElement, Legend, Tooltip } from 'chart.js';
import ChartJS from 'chart.js/auto';

import { DashboardMetricCardWrapper } from 'components/dashboard-metric-card';
import { useScheduleProgress } from 'store/apis';
import { CustomScatterChart } from './custom-scatter-chart';

ChartJS.register(LinearScale, CategoryScale, Filler, BarElement, PointElement, LineElement, Legend, Tooltip);

interface ChartScheduleProgressProps {
  buildingId: number;
}

export const ChartScheduleProgress = ({ buildingId }: ChartScheduleProgressProps) => {
  const { data, isFetching } = useScheduleProgress({ buildingId });

  return (
    <DashboardMetricCardWrapper
      title="Schedule Progress"
      subtitle="Per Zone"
      loading={isFetching}
      loadingText="Loading schedules..."
    >
      <CustomScatterChart min={-23} max={23} offset={20} data={data} />
    </DashboardMetricCardWrapper>
  );
};
